import React, { useEffect } from 'react';
import { SitePreviewPreview } from './SitePreviewPreview';
import styles from './SitePreview.scss';
import { SitePreviewContent } from './components/SitePreviewContent';
import { useSelectedStoreName } from 'stores/appStore';
import { useGTM } from 'hooks/useGTM';
import premiumHalfOff from 'assets/images/premium-half-off.png';
import { globalConfig } from 'config/client';
import { getProductCount, getSubIdConfig } from 'config/providers';
import { buildSitePreviewViewModel } from './sitePreviewViewModel';
import { DEFAULT_SITE_PREVIEW_EXPERIENCE, SITE_PREVIEW_EXPERIENCE_BY_SUBID_VARIANT } from './sitePreviewExperiences';

export function SitePreview() {
  const { trackPreviewPageView } = useGTM();
  const storeName = useSelectedStoreName();
  const productCount = getProductCount();
  const variant = getSubIdConfig()?.experienceVariant;
  const experience = variant ? SITE_PREVIEW_EXPERIENCE_BY_SUBID_VARIANT[variant] : DEFAULT_SITE_PREVIEW_EXPERIENCE;
  const viewModel = buildSitePreviewViewModel({
    experience,
    config: globalConfig.sitePreviewConfig,
  });

  useEffect(() => {
    trackPreviewPageView(storeName || undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.sitePreview}>
      {viewModel.showHalfOffImage && (
        <div className={styles.sitePreviewHalfOff}>
          <img src={premiumHalfOff} alt="premium half off" />
        </div>
      )}
      <div className={styles.sitePreviewContent}>
        <SitePreviewContent viewModel={viewModel} productCount={productCount} />
      </div>
      <div className={styles.sitePreviewPreview}>
        <SitePreviewPreview />
      </div>
    </div>
  );
}
